import AjaxForm from '../models/AjaxForm'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

function initTargetBlankForms () {
  document.querySelectorAll('form[target=_blank]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault()
      form.submit()
      form.reset()
    })
  })
}

function initDateTimePickers () {
  flatpickr('.datepicker', {
    dateFormat: 'd.m.Y',
  })

  flatpickr('.timepicker', {
    enableTime: true,
    noCalendar: true,
    minuteIncrement: "15",
    dateFormat: 'H:i',
    time_24hr: true,
  })
}

function initNumerableGroups () {
  document.querySelectorAll('.form-group.numerable').forEach(group => {
    const checkbox = group.querySelector('input[type=checkbox]')
    const numberGroup = group.querySelector('.number-group')
    const numberInput = numberGroup.querySelector('input[type=number]')
    checkbox.dataset.value = checkbox.dataset.value || checkbox.value

    checkbox.addEventListener('change', e => {
      numberGroup.classList.toggle('disabled', !checkbox.checked)
      checkbox.value = checkbox.dataset.value + ` (${numberInput.value})`
    })

    numberInput.addEventListener('change', e => {
      checkbox.value = checkbox.dataset.value + ` (${numberInput.value})`
    })
  })
}

export default function () {
  initTargetBlankForms()
  document.querySelectorAll('[ajax-form]').forEach(form => new AjaxForm(form))
  initDateTimePickers()
  initNumerableGroups()
}



// WEBPACK FOOTER //
// ./themes/default/js/modules/forms.js